import { render, staticRenderFns } from "./inviteAssistances.vue?vue&type=template&id=ba264aa6&"
import script from "./inviteAssistances.vue?vue&type=script&lang=js&"
export * from "./inviteAssistances.vue?vue&type=script&lang=js&"
import style0 from "./inviteAssistances.vue?vue&type=style&index=0&id=ba264aa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports